import React from "react"
import Project1 from "../Color_guessing_game.png"
import Project2 from "../Face_recognition.jpeg"
import Project3 from "../Personal_portfolio.jpeg"
import Project4 from "../object_detection.jpeg"
import Project5 from "../To-do-list.png"
import Project6 from "../bhp.png"
import Project7 from "../mi.png"
import Project8 from "../shopping.png"
import Project9 from "../weather.png"
const Projects = () => {
    return (
        <div className="container">
          <div className = "d-flex justify-content-center my-5">
            <h1 className="h1_color">LATEST PROJECTS</h1>
          </div>
          <div id="projects" className="row row-cols-1 row-cols-md-3 g-4 ">
          

          <div className="col">
              <div className="card">
                <img src={Project8} className="card-img-top " alt="Face_recognition"/>
                <div className="card-body">
                  <h5 className="card-title">Shopping cart</h5>
                  <p className="card-text">The goal of this project is to demonstrate how to add cart functionality to your products page so multiple products can be added to a cart.</p>
                  <a href="https://shoppingcart-website.netlify.app/"><button type="button" class="btn btn-primary">KNOW MORE</button></a>
                </div>
              </div>
            </div>
          <div className="col">
              <div className="card">
                <img src={Project7} className="card-img-top" alt="Face_recognition"/>
                <div className="card-body">
                  <h5 className="card-title">Mi-store-clone</h5>
                  <p className="card-text">This is the cloned version of Mi store. reactjs ,bootstrap are used in this project.</p>
                  <a href="https://mi-store-website.netlify.app/"><button type="button" class="btn btn-primary">KNOW MORE</button></a>
                </div>
              </div>
            </div>
            <div className="col">
              <div className="card">
                <img src={Project1} className="card-img-top" alt="color-guesing-game"/>
                <div className="card-body">
                  <h5 className="card-title">Color Guessing Game</h5>
                  <p className="card-text">This is a Color guessing game in where you will be provided random RGB color and based on that RGB you have to guess the right color.</p>
                  <a href="https://random-rgb-color-game.netlify.app/"><button type="button" class="btn btn-primary">KNOW MORE</button></a>

                </div>
              </div>
            </div>
            <div className="col">
              <div className="card">
                <img src={Project9} className="card-img-top " alt="Face_recognition"/>
                <div className="card-body">
                  <h5 className="card-title">Weather Forecast</h5>
                  <p className="card-text">Reactjs and openweathermap API is used in this project</p>
                  <a href="https://weatherforecast-apps.netlify.app/"><button type="button" class="btn btn-primary">KNOW MORE</button></a>
                </div>
              </div>
            </div>
            <div className="col">
              <div className="card">
                <img src={Project2} className="card-img-top" alt="Face_recognition"/>
                <div className="card-body">
                  <h5 className="card-title">Face Recognition & Attandence Project</h5>
                  <p className="card-text">Face recognition is the technique in which the identity of a human being can be identified using ones individual face.</p>
                  <a href="https://github.com/ajitk26/Face-recognition-and-attendance-project"><button type="button" class="btn btn-primary">KNOW MORE</button></a>
                </div>
              </div>
            </div>
            <div className="col">
              <div className="card">
                <img src={Project3} className="card-img-top" alt="Personal_portfolio"/>
                <div className="card-body">
                  <h5 className="card-title">Personal Portfolio</h5>
                  <p className="card-text">This is my personal portfolio website where i host all the projects and show my abilities and skills React,javascript and firebase is used in this project.</p>
                  <a href="https://github.com/ajitk26/my-portfolio"><button type="button" class="btn btn-primary">KNOW MORE</button></a>
                </div>
              </div>
            </div>
            <div className="col">
              <div className="card">
                <img src={Project4} className="card-img-top" alt="object_detection"/>
                <div className="card-body">
                  <h5 className="card-title">Object Detection</h5>
                  <p className="card-text">This is a object detection project which detects the object in real time with good amount of accuracy.</p>
                  <button type="button" class="btn btn-primary">KNOW MORE</button>
                </div>
              </div>
            </div>
            <div className="col">
              <div className="card">
                <img src={Project5} className="card-img-top" alt="To-do-list"/>
                <div className="card-body">
                  <h5 className="card-title">To-Do-List</h5>
                  <p className="card-text">This is a To-Do application where we can add our daily task.This application is made using html,css and javascript</p>
                  <a href="https://todolist-web-apps.netlify.app/"><button type="button" class="btn btn-primary">KNOW MORE</button></a>
                </div>
              </div>
            </div>
            <div className="col">
              <div className="card">
                <img src={Project6} className="card-img-top" alt="object_detection"/>
                <div className="card-body">
                  <h5 className="card-title">Bengaluru Real Estate Price Prediction</h5>
                  <p className="card-text">This project aims to analyze  the accuracy of predicting house prices of banglore when using multiple linear,random forest regression algorithms and artificial neural network.</p>
                  <a href="https://github.com/ajitk26/Face-recognition-and-attendance-project"><button type="button" class="btn btn-primary">KNOW MORE</button></a>
                </div>
              </div>
            </div>
          </div>
        </div>
    )
}

export default Projects
